<template>
  <div>
    <div
      :title="mandatory ? $t('Primary market cannot be deselected') : ''"
      class="col-sm-6 col-xs-6"
    >
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <input-checkbox
        :disabled="isDisabled"
        :checked="isSelected"
        :name="`${inputName}[${id}][id]`"
        :model-value="id"
        @change="toggleSelected"
      >
        <slot />
      </input-checkbox>
    </div>
    <div v-show="isSelected && showOptions">
      <div class="col-sm-3 col-xs-3 small">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <input-checkbox
          :disabled="isOnsiteDisabled"
          :checked="isOnsiteSelected && isSelected"
          :name="`${inputName}[${id}][is_onsite]`"
          :additional-class="'market-col'"
          :tooltip="
            $t('On site: Being able to attend meetings or even work full time at the job location')
          "
          :title="isOnsiteDisabled ? $t('At least one option is required') : ''"
          @change="toggleOnsiteSelected"
        >
          {{ $t('On site') }}
        </input-checkbox>
      </div>
      <div v-show="isSelected" class="col-sm-3 col-xs-3 small">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <input-checkbox
          :disabled="isRemoteDisabled"
          :checked="isRemoteSelected && isSelected"
          :name="`${inputName}[${id}][is_remote]`"
          :additional-class="'market-col'"
          :tooltip="$t('Remote: Work and deliver from your current location')"
          :title="isRemoteDisabled ? $t('At least one option is required') : ''"
          @change="toggleRemoteSelected"
        >
          {{ $t('Remote') }}
        </input-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inputName: { type: String, required: true },
    id: { required: true },
    isSelected: { type: Boolean, required: true },
    // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
    showOptions: { type: Boolean, default: true },
    isOnsiteSelected: { type: Boolean, required: true },
    isRemoteSelected: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
    mandatory: { type: Boolean, default: false },
  },
  computed: {
    atLeastOneOptionSelected() {
      return this.isOnsiteSelected || this.isRemoteSelected
    },
    isDisabled() {
      return !!(this.disabled || (this.mandatory && this.isSelected !== false))
    },
    isOnsiteDisabled() {
      if (this.disabled) {
        return true
      }
      // If this group is mandatory, only allow deselecting onsite if remote is selected
      // But dont disable if none are selected, so as to allow selecting it
      return this.mandatory && this.isOnsiteSelected && !this.isRemoteSelected
    },
    isRemoteDisabled() {
      if (this.disabled) {
        return true
      }
      // If this group is mandatory, only allow deselecting remote if onsite is selected
      // But dont disable if none are selected, so as to allow selecting it
      return this.mandatory && this.isRemoteSelected && !this.isOnsiteSelected
    },
  },
  watch: {
    isSelected(newIsSelected) {
      // Select on-site and remote when toggling parent on
      // Unless we have a previous user selection with either on-site or remote
      if (!this.atLeastOneOptionSelected && newIsSelected) {
        this.$emit('toggle-onsite-selected', this.id, true)
        this.$emit('toggle-remote-selected', this.id, true)
      }
    },
    isOnsiteSelected() {
      this.updateMainSelectionValidity()
    },
    isRemoteSelected() {
      this.updateMainSelectionValidity()
    },
  },
  methods: {
    toggleSelected(value, checked) {
      this.$emit('toggle-selected', this.id, checked)
    },
    toggleOnsiteSelected(value, checked) {
      this.$emit('toggle-onsite-selected', this.id, checked)
    },
    toggleRemoteSelected(value, checked) {
      this.$emit('toggle-remote-selected', this.id, checked)
    },
    // The main item (market or region) must be de-selected
    // if neither onsite nor remote are selected
    updateMainSelectionValidity() {
      if (!this.atLeastOneOptionSelected) {
        this.toggleSelected(this.id, false)
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
